import * as React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

export function toDataUrl<P extends object>(
  component: React.FunctionComponent<P> | React.ComponentClass<P> | keyof React.JSX.IntrinsicElements,
  props: P,
): string {
  const svgToString = renderToStaticMarkup(React.createElement(component, props))
  try {
    return `data:image/svg+xml;utf8, ${encodeURIComponent(svgToString)}`
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(component, props)
    console.error(e)
    return ''
  }
}
